import React from "react";
import "../../Components/Boot/Boot.css";
import "./TermsCondition.css";
import Navbar from "../../Components/Navbar/Navbar";
import Footer from "../../Components/Footer/Footer";
import MobileFooter from "../../Components/Mobile/MobileFooter";

function TermsCondition() {
  return (
    <div>
      <Navbar />
      <div className="terms-wrapper d-flex align-items-center justify-content-center mb-3">
        <div className="terms-container">
          <h1>TB Mart - Terms and Conditions</h1>
          <p className="last-updated">Last Updated: August 11, 2025</p>

          <section>
            <h2>1. Introduction and Acceptance of Terms</h2>
            <p>
              Welcome to TB Mart. These Terms and Conditions ("Terms") are a
              legally binding agreement between you and TrendBay Daily Solutions
              Ltd ("we," "us," "our," or "TB Mart") governing your use of our
              services.
            </p>
            <p>Our services include:</p>
            <ul>
              <li>
                <strong>TB Mart Grocery Service:</strong> An online platform for
                ordering groceries and daily essentials for delivery.
              </li>
              <li>
                <strong>Reup Vault Marketplace:</strong> A platform that allows
                independent users to list new and pre-owned items and connects
                potential buyers with sellers.
              </li>
            </ul>
            <p>
              By creating an account, accessing, or using any part of our
              website or mobile application (collectively, the "Service"), you
              acknowledge that you have read, understood, and agree to be bound
              by these Terms and our Privacy Policy. If you do not agree to
              these Terms, you must not use the Service.
            </p>
          </section>

          <section>
            <h2>2. Definitions</h2>
            <ul>
              <li>
                <strong>"Service":</strong> refers to all services provided by
                TB Mart, encompassing both the TB Mart Grocery Service and the
                Reup Vault Marketplace.
              </li>
              <li>
                <strong>"User," "You," "Your":</strong> refers to any individual
                who accesses or uses the Service, including registered account
                holders.
              </li>
              <li>
                <strong>"TB Mart Grocery Service":</strong> refers specifically
                to the e-commerce platform for ordering, paying for, and
                receiving delivery of groceries and essentials directly from TB
                Mart.
              </li>
              <li>
                <strong>"Reup Vault Marketplace" or "Reup Vault":</strong>{" "}
                refers to the platform that enables Users to list items for sale
                and facilitates contact between Buyers and Sellers.
              </li>
              <li>
                <strong>"Seller":</strong> refers to a User who lists an item
                for sale on the Reup Vault Marketplace.
              </li>
              <li>
                <strong>"Buyer":</strong> refers to a User who expresses
                interest in or purchases an item from a Seller on the Reup Vault
                Marketplace.
              </li>
            </ul>
          </section>

          <section>
            <h2>3. User Eligibility and Account Registration</h2>
            <p>
              To use the Service, you must be at least 18 years old and capable
              of entering into a legally binding contract. You are responsible
              for providing accurate registration information and for
              maintaining the security of your account password.
            </p>
          </section>

          <h3>PART A: TERMS FOR TB MART GROCERY SERVICE</h3>
          <section>
            <h2>4. Ordering, Payment, and Delivery</h2>
            <ol>
              <li>
                <strong>Ordering:</strong> Placing an item in your cart and
                completing checkout constitutes an offer to purchase. We will
                confirm receipt of your order, but a contract is only formed
                when we dispatch the goods. We reserve the right to cancel
                orders due to stock unavailability or pricing errors.
              </li>
              <li>
                <strong>Pricing and Payment:</strong> All prices are in Nigerian
                Naira (NGN) and include VAT. Delivery fees are added at
                checkout. We accept payments via our secure online gateway and
                other methods as specified.
              </li>
              <li>
                <strong>Delivery:</strong> We deliver to specified areas in
                Lagos and Abuja. While we provide estimated delivery times,
                these are not guaranteed. Risk of loss passes to you upon
                delivery.
              </li>
              <li>
                <strong>Returns and Refunds:</strong> Our Refund Policy governs
                all returns and refunds for the TB Mart Grocery Service. In
                summary, you may request a refund within 4 hours of delivery for
                items that are wrong, missing, damaged, or expired, with
                mandatory photographic evidence.
              </li>
            </ol>
          </section>

          <h3>PART B: TERMS FOR REUP VAULT MARKETPLACE</h3>
          <section>
            <h2>5. Our Role and Disclaimer of Involvement</h2>
            <ol>
              <li>
                <strong>Platform Only:</strong> The Reup Vault Marketplace is a
                platform that allows Sellers to list items and Buyers to find
                them. TB Mart is not a party to any transaction between a Buyer
                and a Seller.
              </li>
              <li>
                <strong>No Involvement:</strong> We do not process payments,
                handle shipping or delivery, hold inventory, or act as an escrow
                agent for any Reup Vault transaction. All aspects of a
                transaction, including negotiation, payment, and delivery, are
                arranged and conducted directly between the Buyer and Seller.
              </li>
            </ol>
          </section>

          <section>
            <h2>6. Responsibilities and Conduct</h2>
            <ol>
              <li>
                <strong>Seller Responsibilities:</strong> As a Seller, you are
                solely responsible for:
                <ul>
                  <li>
                    The accuracy, legality, and quality of your listings and the
                    items you sell.
                  </li>
                  <li>Communicating directly with Buyers.</li>
                  <li>Fulfilling all agreements made with a Buyer.</li>
                </ul>
              </li>
              <li>
                <strong>Buyer Responsibilities:</strong> As a Buyer, you are
                solely responsible for:
                <ul>
                  <li>
                    Conducting your own due diligence before purchasing an item.
                  </li>
                  <li>Communicating and negotiating directly with Sellers.</li>
                  <li>
                    Arranging payment and collection/delivery with the Seller.
                  </li>
                </ul>
              </li>
            </ol>
          </section>

          <section>
            <h2>7. Disclaimer of Liability for Reup Vault Transactions</h2>
            <p>
              TB Mart provides the Reup Vault Marketplace "as is" without any
              warranties. We do not guarantee the authenticity, quality, safety,
              or legality of items listed. We do not vet users and are not
              responsible for the conduct of any Buyer or Seller.
            </p>
            <p>
              You agree that TB Mart has no liability for any disputes, losses,
              or damages of any kind arising from or related to your use of the
              Reup Vault Marketplace or any transaction you enter into. Any
              claims must be made directly against the other party (Buyer or
              Seller).
            </p>
          </section>

          <h3>PART C: GENERAL TERMS FOR ALL SERVICES</h3>
          <section>
            <h2>8. User Conduct and Prohibited Activities</h2>
            <ul>
              <li>Violate any Nigerian law or regulation.</li>
              <li>List illegal, counterfeit, stolen, or hazardous items.</li>
              <li>Engage in fraud, spamming, or harassment.</li>
              <li>
                Infringe upon any third-party's intellectual property rights.
              </li>
              <li>Distribute viruses or any other harmful computer code.</li>
            </ul>
          </section>

          <section>
            <h2>9. Intellectual Property</h2>
            <p>
              All content on the Service, including the TB Mart logo, text, and
              software, is the property of TrendBay Daily Solutions Ltd and is
              protected by copyright and trademark laws.
            </p>
          </section>

          <section>
            <h2>10. Privacy and Data Protection</h2>
            <p>
              Our use of your personal data is governed by our Privacy Policy,
              which details how we collect, use, and protect your information.
            </p>
          </section>

          <section>
            <h2>11. Limitation of Liability and Indemnification</h2>
            <p>
              To the fullest extent permitted by law, TrendBay Daily Solutions
              Ltd shall not be liable for any indirect, incidental, or
              consequential damages arising from your use of the Service.
            </p>
            <p>
              You agree to indemnify and hold harmless TrendBay Daily Solutions
              Ltd, its directors, and employees from any claim or demand,
              including reasonable legal fees, arising out of your breach of
              these Terms or your violation of any law or the rights of a third
              party.
            </p>
          </section>

          <section>
            <h2>12. Governing Law and Dispute Resolution</h2>
            <p>
              These Terms are governed by the laws of the Federal Republic of
              Nigeria.
            </p>
            <ul>
              <li>
                <strong>TB Mart Grocery Service:</strong> Any disputes should
                first be directed to our Customer Support.
              </li>
              <li>
                <strong>Reup Vault Marketplace:</strong> All disputes are
                strictly between the Buyer and Seller. TB Mart will not mediate
                or resolve such disputes.
              </li>
            </ul>
            <p>
              Unresolved legal disputes shall be submitted to the exclusive
              jurisdiction of the courts located in Lagos, Nigeria.
            </p>
          </section>

          <section>
            <h2>13. Modification of Terms and Termination</h2>
            <p>
              We reserve the right to modify these Terms at any time. We will
              provide notice of material changes. Your continued use of the
              Service after such changes constitutes your acceptance of the new
              Terms. We may suspend or terminate your account at our discretion
              if you violate these Terms.
            </p>
          </section>

          <section>
            <h2>14. Contact Information</h2>
            <p>
              For any questions about these Terms, please contact us: <br />
              TrendBay Daily Solutions Ltd <br />
              Email:{" "}
              <a href="mailto:help@trendbayds.com">help@trendbayds.com</a>
            </p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default TermsCondition;
